import { Field as BaseField } from "rc-field-form";
import { useTranslation } from "react-i18next";
import { Input } from "reactstrap";
import Field from "../../../../../components/Field";
import Select from "../../../../../components/Inputs/Select";
import Switch from "../../../../../components/Inputs/Switch";

function Probation({ disabled }) {
    const { t } = useTranslation();

    return (
        <div className="rounded my-4 p-4" style={{ background: "#f8f9f9" }}>
            <Field name="probation" shouldUpdate className="mb-0">
                {({ value, onChange }) => {
                    return (
                        <Switch
                            checked={!!value}
                            onChange={(e) => {
                                let value = null;
                                if (e.target.checked) {
                                    value = {
                                        type: "seniorityDate",
                                        value: 0,
                                    };
                                }
                                onChange(value);
                            }}
                            disabled={disabled}
                        >
                            {t("probation")}
                        </Switch>
                    );
                }}
            </Field>

            <BaseField name="probation" shouldUpdate>
                {({ value }) => {
                    if (!value) {
                        return null;
                    }
                    return (
                        <div className="mt-4">
                            <Field
                                name={["probation", "type"]}
                                label={t("probation-type")}
                                disabled={disabled}
                                rules={[
                                    {
                                        required: true,
                                        message: t("probation-type-required"),
                                    },
                                ]}
                            >
                                <Select>
                                    <Select.Option value="seniorityDate">{t("seniority-date")}</Select.Option>
                                    <Select.Option value="hireDate">{t("hire-date")}</Select.Option>
                                </Select>
                            </Field>

                            <Field
                                name={["probation", "value"]}
                                label={t("Days")}
                                disabled={disabled}
                                rules={[
                                    {
                                        required: true,
                                        message: t("required-value"),
                                    },
                                ]}
                            >
                                {({ value, onChange }) => {
                                    return (
                                        <Input
                                            type="number"
                                            value={value}
                                            onChange={(e) => {
                                                onChange(Number(e.target.value));
                                            }}
                                        />
                                    );
                                }}
                            </Field>
                        </div>
                    );
                }}
            </BaseField>
        </div>
    );
}

export default Probation;
